"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ApplicationLayout = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ApplicationLayoutHeader = _interopRequireDefault(require("./ApplicationLayoutHeader"));

var _ApplicationLayoutSidebar = _interopRequireDefault(require("./ApplicationLayoutSidebar"));

var _ApplicationLayoutBody = _interopRequireDefault(require("./ApplicationLayoutBody"));

var _init = require("../../utils/init");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// initializes document bootstrapping - keep the import to avoid being tree-shaked
var ApplicationLayout = function ApplicationLayout(_ref) {
  var className = _ref.className,
      children = _ref.children;
  var classes = (0, _classnames.default)('ApplicationLayout', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, children);
};

exports.ApplicationLayout = ApplicationLayout;
ApplicationLayout.Header = _ApplicationLayoutHeader.default;
ApplicationLayout.Sidebar = _ApplicationLayoutSidebar.default;
ApplicationLayout.Body = _ApplicationLayoutBody.default;
ApplicationLayout.propTypes = {
  className: _propTypes.default.string
};
var _default = ApplicationLayout;
exports.default = _default;